import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthRouteGuard } from '@app/shared/common/auth/auth-route-guard';

const routes: Routes = [
    {
        path: '',
        canActivateChild: [AuthRouteGuard],
        loadChildren: () => import('app/app.module').then((m) => m.AppModule), // Lazy load account module
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules,
        }),
    ],
    exports: [RouterModule],
    providers: [],
})
export class RootRoutingModule {}
